const statuses = ['ACTIVE', 'INACTIVE', 'INSHOP', 'RETIRED'];

const reasons = [
  'DRIVERISSUE',
  'CLEANING',
  'INSPECTION',
  'INSTALLATION',
  'ACCIDENT',
  'PLANNEDMAINETANCE',
  'UNPLANNEDREPAIR',
  'PREPARATION',
  'RETIRED',
  'TEMPORARY',
  'OTHER',
];

export { statuses, reasons };
